import styled from 'styled-components';

export const Carousel = styled.div`
	color: #64778f;
	height: 540px;

	img {
		vertical-align: middle;
	}
`;

export const TitleCard = styled.div`
	font-family: 'Montserrat', 'Arial', 'Roboto', 'Helvetica', 'sans-serif';
	width: 100%;
	display: grid;
	margin: 5px 0 10px 0;

	min-height: 74px;

	p {
		font-weight: 800;
		margin: auto;
		font-size: 30px;
		display: flex;
		place-items: center;
		text-align: center;
		color: #64778f;
	}
`;

export const SubtitleCard = styled.div`
	padding: 15px;
	text-align: center;
`;

export const Description = styled.div`
	top: 0;
	font-weight: 600;
	font-size: 16px;
	padding: 8px 18px;
	bottom: 8px;
	width: 100%;
	height: 100px;
	text-align: center;
	color: #64778f;
`;

export const Slides = styled.div<{ active: boolean }>`
	display: ${({ active }) => (active ? 'block' : 'none')};
	animation-name: fade;
	animation-duration: 1.5s;

	@keyframes fade {
		from {
			opacity: 0.4;
		}
		to {
			opacity: 1;
		}
	}
`;

export const SlideshowContainer = styled.div`
	max-width: 1000px;
	position: relative;
	margin: auto;
`;

export const ImageContainer = styled.div<{ hasSubtitle?: boolean }>`
	width: 300px;
	height: ${({ hasSubtitle }) => (hasSubtitle ? '215px' : '300px')};
	margin: auto;
	text-align: center;
`;

export const DotContainer = styled.div`
	display: flex;
	justify-content: center;
	text-align: center;
	margin-bottom: 30px;
`;

export const Dot = styled.span<{ active: boolean }>`
	height: 10px;
	width: 10px;
	margin: 0 2px;
	background-color: ${({ active }) => (active ? '#717171' : '#d8dee6')};
	border-radius: 50%;
	display: inline-block;
	transition: background-color 0.6s ease;
`;

export const ActionContainer = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: center;
	gap: 30px;
	margin-top: 35px;
`;
